var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoOctagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.15019 14.3624L0.137695 10.35V4.6312L4.15019 0.637451H9.86894L13.8627 4.6312V10.35L9.86894 14.3624H4.15019ZM7.00019 11.3062C7.18769 11.3062 7.35332 11.2374 7.49707 11.0999C7.64082 10.9624 7.71269 10.7937 7.71269 10.5937C7.71269 10.4062 7.64082 10.2437 7.49707 10.1062C7.35332 9.9687 7.18769 9.89995 7.00019 9.89995C6.81269 9.89995 6.64707 9.9687 6.50332 10.1062C6.35957 10.2437 6.2877 10.4062 6.2877 10.5937C6.2877 10.7937 6.35957 10.9624 6.50332 11.0999C6.64707 11.2374 6.81269 11.3062 7.00019 11.3062ZM6.41894 8.62495H7.58144V3.5437H6.41894V8.62495ZM4.67519 13.0875H9.32519L12.5877 9.82495V5.17495L9.32519 1.91245H4.67519L1.4127 5.17495V9.82495L4.67519 13.0875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOctagon);
export default __webpack_public_path__ + "static/media/infoOctagon.b9fbbbd3.svg";
export { ForwardRef as ReactComponent };